"use client";

import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";
import ShowChatButton from "./show-chat";
import { useTranslations } from "next-intl";

const socialLinks = [
  {
    name: "Discord",
    href: "https://discord.gg/6qtJUn2yxP",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="h-5 w-5">
        <path d="M20.317 4.369a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.211.375-.444.864-.608 1.25a18.34 18.34 0 0 0-5.487 0 12.23 12.23 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.684 4.37a.07.07 0 0 0-.032.027C.533 9.063-.32 13.579.099 18.057a.083.083 0 0 0 .031.056 19.9 19.9 0 0 0 5.993 3.043.077.077 0 0 0 .084-.027c.462-.631.873-1.295 1.226-1.987a.076.076 0 0 0-.041-.105 13.136 13.136 0 0 1-1.872-.893.078.078 0 0 1-.008-.129c.126-.094.252-.192.371-.291a.074.074 0 0 1 .077-.01c3.927 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.009c.119.099.245.197.372.292a.078.078 0 0 1-.006.13c-.601.35-1.228.657-1.873.894a.076.076 0 0 0-.04.104c.36.692.77 1.356 1.225 1.987a.076.076 0 0 0 .084.028 19.876 19.876 0 0 0 6.003-3.043.076.076 0 0 0 .03-.056c.5-5.177-.838-9.653-3.548-13.66a.061.061 0 0 0-.03-.028ZM8.02 15.331c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.418 2.157-2.418 1.212 0 2.176 1.094 2.157 2.418 0 1.334-.955 2.419-2.157 2.419Zm7.974 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.418 2.157-2.418 1.212 0 2.176 1.094 2.157 2.418 0 1.334-.945 2.419-2.157 2.419Z" />
      </svg>
    ),
  },
  {
    name: "Telegram",
    href: "https://t.me/thunderproxynetwork",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="h-5 w-5">
        <path d="M9.04 17.54c-.33 0-.28-.13-.4-.46l-1-3.34L17.76 7.3" />
        <path d="M9.04 17.54c.25 0 .36-.12.5-.26l2.07-2.02-2.6-1.57" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.58 20c-.8 0-1.08-.38-1.5-1.25l-1.43-4.7L3.22 12.4c-1.16-.36-1.14-1.13.24-1.6L20.3 5.3c.87-.34 1.63.2 1.34 1.54l-2.52 11.9c-.2.94-.76 1.17-1.53.73l-4.24-3.14-2.05 1.96c-.29.29-.52.52-1.05.52Z"
        />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    href: "https://linkedin.com/company/thunderproxy-com",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="h-5 w-5">
        <path d="M19 0h-14C2.2 0 0 2.2 0 5v14c0 2.8 2.2 5 5 5h14c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5Zm-9.5 19H7V9.5h2.5V19Zm-1.2-10.9c-.8 0-1.3-.5-1.3-1.2 0-.7.5-1.2 1.3-1.2s1.3.5 1.3 1.2-.5 1.2-1.3 1.2Zm11.2 10.9h-2.5v-4.6c0-1.2-.4-2-1.5-2s-1.7.8-1.7 2v4.6h-2.5V9.5h2.5v1.3c.3-.6 1.2-1.5 2.7-1.5 1.9 0 3.2 1.3 3.2 3.8V19Z" />
      </svg>
    ),
  },
];

export default function FooterContact() {
  const t = useTranslations("footer.contact");

  return (
    <div className="flex flex-col gap-2 text-sm">
      <p className="font-medium">{t("title")}</p>
      <p className="text-muted-foreground">
        {t("emailLabel")}&nbsp;
        <a
          href="mailto:help@thunderproxy.com"
          className={cn(buttonVariants({ variant: "link", size: "sm" }), "px-0 text-sm")}
        >
          {t("emailValue")}
        </a>
      </p>
      <p className="text-muted-foreground">
        {t("chatLabel")} <ShowChatButton />
      </p>

      {/* Social Media Icons */}
      <div className="flex gap-3 pt-2">
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.name}
            className="text-muted-foreground transition-colors hover:text-primary"
          >
            {link.icon}
          </a>
        ))}
      </div>
    </div>
  );
}
